import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';
import { Meta } from '@angular/platform-browser';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-product-pos',
  templateUrl: './product-pos.component.html',
  styleUrls: ['./product-pos.component.css']
})
export class ProductPOSComponent implements OnInit {
  //constructor(){}
  //commentted and new code added by Digvijay on 17-06-2019
  constructor(private meta: Meta,private titleService: Title, private location: Location) {
    this.meta.addTag({ name: 'description', content: 'Offering point of sale systems for small business, retail, inventory for over 27 years. Get affordable POS software solutions for easy management ' },true);
    //this.meta.addTag({ name: 'description', content: 'POS-Software ' },true);
    this.meta.addTag({ name: 'author', content: 'ShreeMon' },true);
    this.meta.addTag({ name: 'keywords', content: 'billing software for retail shop,grocery store, point of sale software,pos system,retail point of sale,retail pos,pos system,pos software, retail pos,retail point of sale,point of sale software,pos,point of sale,billing software for retail shop,retail software,pos system software,point of sale systems' },true);    this.titleService.setTitle('Retail POS Software | Point of Sale Billing System | Shreemon');
  }
  ngOnInit() {  
    this.location.replaceState("/Product/POS-Software");
  }
 
}
